(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ev-collection"]) return;
  try {
    
(()=>{
  if(window.evCollectionBrowseBound)return;
  window.evCollectionBrowseBound=true;
  let pending;
  function positionStrip(root){
    const strip=root.querySelector('.ev-collection-tabs');
    const active=strip?.querySelector('[aria-current="page"]');
    if(strip&&active)strip.scrollLeft=Math.max(0,active.offsetLeft-strip.offsetLeft-16);
  }
  async function browse(destination,push){
    const current=document.querySelector('[data-ev-collection]');
    if(!current)return;
    pending?.abort();
    const controller=new AbortController();
    pending=controller;
    current.setAttribute('aria-busy','true');
    const url=new URL(destination,location.href);
    const requestURL=new URL(url);
    requestURL.hash='';
    requestURL.searchParams.set('section_id',current.dataset.sectionId);
    const preview=new URL(location.href).searchParams.get('preview_theme_id');
    if(preview)requestURL.searchParams.set('preview_theme_id',preview);
    try{
      const response=await fetch(requestURL,{signal:controller.signal});
      if(!response.ok)throw Error('collection');
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');
      const next=doc.querySelector('[data-ev-collection]');
      if(controller.signal.aborted)return;
      if(!next)throw Error('collection');
      const update=()=>{
        current.replaceWith(next);
        document.title=next.dataset.pageTitle;
        if(push)history.pushState({evCollection:true},'',url);
        positionStrip(next);
        const target=next.querySelector('#ev-collection-browse');
        const headerHeight=document.querySelector('.ev-header')?.getBoundingClientRect().height||98;
        if(target)window.scrollTo({top:window.scrollY+target.getBoundingClientRect().top-headerHeight-16,behavior:'instant'});
        if(push)next.querySelector('.ev-collection-tabs [aria-current="page"]')?.focus({preventScroll:true});
      };
      if(document.startViewTransition&&!matchMedia('(prefers-reduced-motion: reduce)').matches){await document.startViewTransition(update).finished}else{update()}
    }catch(error){
      if(error.name!=='AbortError')location.assign(url);
    }finally{
      if(pending===controller){document.querySelector('[data-ev-collection]')?.removeAttribute('aria-busy');pending=null}
    }
  }
  document.addEventListener('click',event=>{
    const link=event.target.closest('[data-ev-collection] a[data-ev-category]');
    if(!link||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||link.target==='_blank')return;
    event.preventDefault();
    browse(link.href,true);
  });
  addEventListener('popstate',()=>{if(document.querySelector('[data-ev-collection]'))browse(location.href,false)});
  function setup(){const root=document.querySelector('[data-ev-collection]');if(root)positionStrip(root)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup,{once:true});else setup();
  document.addEventListener('shopify:section:load',setup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ev-product"]) return;
  try {
    
document.addEventListener('click',e=>{const button=e.target.closest('[data-ev-photo]');if(!button)return;const main=document.querySelector('#ev-main-photo img');if(!main)return;main.src=button.dataset.evPhoto;main.removeAttribute('srcset');main.alt=button.querySelector('img').alt;});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ev-shell"]) return;
  try {
    
(()=>{
function setupHeaderSurface(){
  window.evHeaderCleanup?.();
  const header=document.querySelector('.ev-header');
  if(!header)return;
  const body=document.body;
  const topbar=document.querySelector('.ev-topbar');
  const hero=body.classList.contains('ev-page-index')?document.querySelector('.ev-hero'):null;
  let frame=0;
  function updateSurface(){
    frame=0;
    const pastHero=!hero||hero.getBoundingClientRect().bottom<=header.getBoundingClientRect().bottom+1;
    body.classList.toggle('ev-header-past-hero',pastHero);
  }
  function queueSurface(){if(!frame)frame=requestAnimationFrame(updateSurface)}
  function measureHeader(){
    const height=header.offsetHeight+'px';
    const announcement=(topbar?.offsetHeight||0)+'px';
    if(body.style.getPropertyValue('--ev-header-height')!==height)body.style.setProperty('--ev-header-height',height);
    if(body.style.getPropertyValue('--ev-announcement-height')!==announcement)body.style.setProperty('--ev-announcement-height',announcement);
    queueSurface();
  }
  const observer=new ResizeObserver(measureHeader);
  [header,topbar,hero].filter(Boolean).forEach(element=>observer.observe(element));
  window.addEventListener('scroll',queueSurface,{passive:true});
  window.addEventListener('resize',measureHeader,{passive:true});
  window.addEventListener('pageshow',measureHeader);
  measureHeader();
  window.evHeaderCleanup=()=>{
    observer.disconnect();
    cancelAnimationFrame(frame);
    window.removeEventListener('scroll',queueSurface);
    window.removeEventListener('resize',measureHeader);
    window.removeEventListener('pageshow',measureHeader);
  };
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setupHeaderSurface,{once:true});
else setupHeaderSurface();
document.addEventListener('shopify:section:load',setupHeaderSurface);
document.addEventListener('shopify:section:unload',()=>requestAnimationFrame(setupHeaderSurface));
})();
(()=>{if(window.evBound)return;window.evBound=true;const config=()=>document.getElementById('ev-config');const root=()=>config().dataset.root;function announce(s){document.getElementById('ev-status').textContent=s}function open(id){const d=document.getElementById(id);if(d&&!d.open)d.showModal()}async function refresh(){const r=await fetch(root()+'?section_id=ev-shell');if(!r.ok)throw Error(config().dataset.error);const doc=new DOMParser().parseFromString(await r.text(),'text/html');const content=doc.getElementById('ev-cart-body');if(!content)throw Error(config().dataset.error);document.getElementById('ev-cart-body').innerHTML=content.innerHTML;const n=doc.querySelector('[data-ev-count]')?.textContent;document.querySelectorAll('[data-ev-count]').forEach(e=>e.textContent=n||'0')}document.addEventListener('click',async e=>{const menu=document.querySelector('.ev-shop-menu');if(menu?.open&&!menu.contains(e.target))menu.open=false;const opener=e.target.closest('[data-ev-open]');if(opener){open(opener.dataset.evOpen);return}const cart=e.target.closest('[data-ev-cart]');if(cart){e.preventDefault();open('ev-cart');return}if(e.target.closest('[data-ev-close]')){e.target.closest('dialog').close();return}if(e.target.tagName==='DIALOG'&&e.target.open){const box=e.target.getBoundingClientRect();if(e.clientX<box.left||e.clientX>box.right||e.clientY<box.top||e.clientY>box.bottom)e.target.close()}const scroll=e.target.closest('[data-ev-scroll]');if(scroll){document.querySelector(scroll.dataset.target)?.scrollBy({left:Number(scroll.dataset.evScroll)*330,behavior:'smooth'});return}const qty=e.target.closest('[data-ev-qty]');if(qty){const box=qty.closest('.ev-qty'),input=box.querySelector('input'),value=Math.max(Number(input.min||0),Number(input.value)+Number(qty.dataset.evQty));input.value=value;if(box.dataset.key){qty.disabled=true;try{const res=await fetch(config().dataset.change+'.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:box.dataset.key,quantity:value})});const data=await res.json();if(!res.ok)throw Error(data.description||config().dataset.error);await refresh()}catch(err){announce(err.message);qty.disabled=false}}}});document.addEventListener('keydown',e=>{if(e.key==='Escape'){const menu=document.querySelector('.ev-shop-menu');if(menu?.open){menu.open=false;menu.querySelector('summary').focus()}}});document.addEventListener('submit',async e=>{const form=e.target.closest('[data-ev-add]');if(!form)return;e.preventDefault();const btn=form.querySelector('[type=submit]'),err=form.querySelector('.ev-error');btn.disabled=true;if(err)err.textContent='';try{const res=await fetch(config().dataset.add+'.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});const data=await res.json();if(!res.ok)throw Error(data.description||config().dataset.error);await refresh();open('ev-cart');announce(config().dataset.added)}catch(error){if(err)err.textContent=error.message;announce(error.message)}finally{btn.disabled=false}});document.addEventListener('change',e=>{if(e.target.matches('[data-ev-sort]'))e.target.form.submit();if(e.target.matches('[data-ev-variant]')){const opt=e.target.selectedOptions[0],form=e.target.closest('form');form.querySelector('[type=submit]').disabled=opt.dataset.available!=='true';const price=document.querySelector('[data-ev-product-price]');if(price)price.textContent=opt.dataset.price}});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
